var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.743 4.186s-13.698 20.3-35.614 8.191C10.214.269-11.702 33.032 7.17 52.975c18.873 19.943.405 30.901 13.226 43.124C34.967 109.99 47.653 81.82 59.22 88.23c25.528 14.148 44.44 8.547 40.179-7.834-7.48-28.756-17.046-30.627-9.74-45.584 7.304-14.958-8.818-46.057-21.916-30.627z",
    fill: "#F0F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.239 54.575v42.588L21.173 82.88l.158-42.434 32.908 14.128z",
    fill: "#465DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.24 54.6v42.588L87.143 83.4V40.583L54.24 54.601z",
    fill: "#7E8EE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m54.239 54.575 33.066-13.85-32.806-14.541-33.326 14.195L54.24 54.575z",
    fill: "#465DD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.143 47.977 45.42 64.129a.454.454 0 0 0 .539-.11l8.28-9.444L21.173 40.38l-9.104 6.826a.452.452 0 0 0 .074.772zM87.305 40.726l9.183 8.302a.455.455 0 0 1-.12.751L63.503 64.447a.453.453 0 0 1-.523-.111l-8.741-9.76 33.066-13.85zM54.498 26.183l32.898 14.542 4.732-1.096a.454.454 0 0 0 .078-.858l-30.04-13.017a.453.453 0 0 0-.209-.036l-7.459.465z",
    fill: "#B5BEEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.498 26.183 21.785 40.447l-4.136-.695a.454.454 0 0 1-.095-.863l30.783-13.266a.455.455 0 0 1 .216-.035l5.946.595z",
    fill: "#B5BEEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/EmptyBox.dc34de02.svg";
export { ForwardRef as ReactComponent };